module.exports = __webpack_public_path__ + "img/gn.f3183aed.jpg";